import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { personName } from '../../utils/people_helpers';

const UsersCell = props => (
  <div className="rt-td--default">
    <span>{_.join(_.map(props.value, person => personName(person)), ', ')}</span>
  </div>
);

UsersCell.propTypes = {
  value: PropTypes.arrayOf(PropTypes.shape({})),
};

export default UsersCell;
